import { useEffect } from 'react';

const ROBOTS = 'noindex, nofollow, noarchive';

/**
 * Keeps a route out of search indexes. Used on /aalogin so Google can recrawl
 * and drop the page (do not also Disallow it in robots.txt).
 */
export default function NoIndexHead({ title = 'Loksy' }) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    const ensureMeta = (name) => {
      let el = document.head.querySelector(`meta[name="${name}"]`);
      const created = !el;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
      }
      const previous = el.getAttribute('content');
      el.setAttribute('content', ROBOTS);
      return { el, created, previous };
    };

    const robots = ensureMeta('robots');
    const googlebot = ensureMeta('googlebot');

    return () => {
      document.title = previousTitle;
      [robots, googlebot].forEach(({ el, created, previous }) => {
        if (created) {
          el.parentNode?.removeChild(el);
        } else if (previous != null) {
          el.setAttribute('content', previous);
        }
      });
    };
  }, [title]);

  return null;
}
